import React from 'react';
import { Triple } from 'react-preloading-component';


const Loading  = (props) => {
  const { loading } = props || true;

  if ( loading ) {
    return (
      <div role= "loading" id="div-loading">
        <Triple color="#f3f4f5" />
      </div>
    )
  } else {
    return (
      null
    )
  }
}

export default Loading
